// src/pages/common/DashboardRedirect.jsx
import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../../services/firebase";
import AdminDashboard from "../admin/AdminDashboard";
import DriverDashboard from "../driver/DriverDashboard";

export default function DashboardRedirect() {
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const snap = await getDoc(doc(db, "users", user.uid));
        setRole(snap.exists() ? snap.data().role : null);
      }
      setLoading(false);
    });
    return () => unsub();
  }, []);

  if (loading) return <p>Loading...</p>;
  if (!role) return <p>Could not determine role.</p>;

  return role === "admin" ? <AdminDashboard /> : <DriverDashboard />;
}
